import React from 'react';
import { css } from '@emotion/react';
import Colors from '../../../types/colors';

interface DownloadFailModalProps {
  open: boolean;
  title?: string;
  message?: string;
  confirmText?: string;
  onConfirm: () => void;
}

// 다운로드(PDF 생성) 실패 시 화면에 띄우는 모달. alert 대체용.
// TODO: 스크린샷 디자인에 맞춰 색/여백/버튼 스타일 미세조정 가능.
const DownloadFailModal = ({ open, title = '다운로드 실패', message = '리포트 다운로드에 실패했습니다.\n잠시 후 다시 시도해주세요.', confirmText = '확인', onConfirm }: DownloadFailModalProps) => {
  if (!open) return null;

  const dim = css`
    position: fixed;
    inset: 0;
    z-index: 10001;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(0, 0, 0, 0.4);
    padding: 0 40px;
  `;
  const card = css`
    width: 100%;
    max-width: 320px;
    background-color: ${Colors['white_regular']};
    border-radius: 16px;
    padding: 28px 20px 16px;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
  `;
  const titleStyle = css`
    font-size: 17px;
    font-weight: 700;
    color: ${Colors['Black_basic']};
    margin: 0 0 10px;
  `;
  const messageStyle = css`
    font-size: 14px;
    font-weight: 400;
    color: ${Colors['Grey_05_subtext']};
    line-height: 1.5;
    white-space: pre-line;
    margin: 0 0 20px;
  `;
  const confirmBtn = css`
    width: 100%;
    height: 48px;
    border: none;
    border-radius: 12px;
    background-color: ${Colors['Primary_100_basic']};
    color: ${Colors['white_regular']};
    font-size: 15px;
    font-weight: 600;
    cursor: pointer;
  `;

  return (
    <div css={dim}>
      <div css={card}>
        {title && <p css={titleStyle}>{title}</p>}
        <p css={messageStyle}>{message}</p>
        <button type="button" css={confirmBtn} onClick={onConfirm}>
          {confirmText}
        </button>
      </div>
    </div>
  );
};

export default DownloadFailModal;
